import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles({
    root: {
        width: '100%',
        "& .MuiLinearProgress-root":{
            height: "2px",
        },
    },
});

export default function ProgressBar() {
    const classes = useStyles();
    const [progress, setProgress] = React.useState(0);

    React.useEffect(() => {
        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                /*if (oldProgress === 100) {
                    return 0;
                }*/
                const diff = Math.random() * 10;
                return Math.min(oldProgress + diff, 100);
            });
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, []);

    return (
        <div className={classes.root}>
            <LinearProgress role="progressbar" aria-label="progressbar" variant="determinate" color="secondary" value={progress} />
        </div>
    );
}
